import { render, staticRenderFns } from "./hostIndex.vue?vue&type=template&id=9643a4ce&scoped=true&"
import script from "./hostIndex.vue?vue&type=script&lang=js&"
export * from "./hostIndex.vue?vue&type=script&lang=js&"
import style0 from "./hostIndex.vue?vue&type=style&index=0&id=9643a4ce&scoped=true&lang=css&"
import style1 from "./hostIndex.vue?vue&type=style&index=1&id=9643a4ce&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9643a4ce",
  null
  
)

export default component.exports